module.exports = __webpack_public_path__ + "static/Mabel-dd6bb20fc432fceae2417edce2b0173f.png";